(function ($) {
  // Document Ready
  $(document).ready(function () {
    if ($(".accordion").length) {
      console.log("accordions.js initiated");

      $(".accordion-tab button").click(function (event) {
        var me = $(this),
          accordionTab = $(this).closest(".accordion-tab"),
          accordionContainer = $(this).closest(".accordion-container"),
          content = accordionTab.find("dd"),
          contentHeight = content.find(".content").outerHeight(true);

        console.log("accordionTab", accordionTab);
        console.log("accordionContainer", accordionContainer);
        console.log("content", content);
        console.log("contentHeight", contentHeight);

        // Toggle current accordion
        if (accordionTab.hasClass("open")) {
          // Close current accordion
          accordionTab.removeClass("open");
          me.attr("aria-expanded", "false");
          content.attr("aria-hidden", "true");
          content.css({
            "max-height": "0",
            position: "relative",
          });
        } else {
          // Close all accordions in the same container
          accordionContainer.find(".accordion-tab").each(function () {
            var tab = $(this);
            tab.removeClass("open");
            tab.find("button").attr("aria-expanded", "false");
            tab.find("dd").attr("aria-hidden", "true").css({
              "max-height": "0",
              position: "relative",
            });
          });

          // Open clicked accordion
          accordionTab.addClass("open");
          me.attr("aria-expanded", "true");
          content.attr("aria-hidden", "false");
          content.css({
            "max-height": contentHeight + "px",
            position: "relative",
          });
        }

        // GSAP Pin Fix -- Adjusted for accordion animation completion
        if (!isMobile) {
          //ScrollTrigger.refresh(true);
        }
      });

      // Update heights on window resize
      $(window).resize(function () {
        $(".accordion-tab.open").each(function () {
          var content = $(this).find("dd");
          var newHeight = content.find(".content").outerHeight(true);
          content.css("max-height", newHeight + "px");
        });

        // ScrollTrigger.refresh();
      });
    }
  });
})(jQuery);
